import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';
import type { AddTaskCommentPayload } from '../types';

export function useTaskCommentMutations(taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const addComment = useMutation({
    mutationFn: (payload: AddTaskCommentPayload) => tasksService.addTaskComment(taskId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: TASK_KEYS.comments(orgId ?? '', taskId, {}),
      });
    },
  });

  const deleteComment = useMutation({
    mutationFn: (commentId: string) => tasksService.deleteTaskComment(taskId, commentId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: TASK_KEYS.comments(orgId ?? '', taskId, {}),
      });
    },
  });

  return { addComment, deleteComment };
}
